module.exports = __webpack_public_path__ + "img/1516323279.acde400b.jpg";